import React, { FC } from 'react';
import { Box, Dialog, Grid, Typography } from '@mui/material';
import { ItemType } from 'api/Responses/BulkUploadResponses';
import Button from 'components/Button';
import { useLanguage } from 'context/AppContext';
import { ModalContent } from 'pages/DeliveryPortal/DeliveryPortalPage.styles';

interface RestoreUploadModalProps {
  open: boolean;
  close: () => void;
  draft: ItemType;
  handleRestoreItem: Function;
}

export type ModalContentType = 'selectItem' | 'selectTray' | 'selectPart';

const RestoreUploadModal: FC<RestoreUploadModalProps> = ({ open, close, draft, handleRestoreItem }) => {
  const [language] = useLanguage();

  const handleClose = (): void => {
    close();
  };

  const restoreItem = (): void => {
    handleRestoreItem(draft);
    close();
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={handleClose}>
      <ModalContent>
        <Box sx={{ display: 'flex', justifyContent: 'between', verticalAlign: 'center', paddingBottom: '20px' }}>
          <Typography variant="h5">
            {language.DataUpload.restoreModal.restoreUpload}
            <Typography variant="subtitle1" style={{ paddingTop: '10px' }}>
              {language.DataUpload.restoreModal.restoreSubtitle}
            </Typography>
          </Typography>
        </Box>
        <Grid container justifyContent="space-between">
          <Button onClick={() => handleClose()}>{language.DataUpload.restoreModal.cancel}</Button>
          <Button onClick={() => restoreItem()}>{language.DataUpload.restoreModal.restore}</Button>
        </Grid>
      </ModalContent>
    </Dialog>
  );
};

export default RestoreUploadModal;
